enum UnlockableCta {
  SeeInfo = "SeeInfo",
  ShareInfo = "ShareInfo",
}

export default UnlockableCta;
